import { useEffect, useState, useMemo } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import dayjs from "dayjs";
import { Box, Typography, Paper, Stack } from "@mui/material";
import {
  ConnectedCallsTable,
  UnreachedCallsTable,
  OtherStatusAnalyticsTable,
  SpecialStatusAnalyticsTable
} from "./features";
import { DATA_TYPE_OPTIONS, generateQueryParams } from "./constants/dataTypeConstants";
import { useAnalyticsSyncDate } from "../../context/analytics-sync-date.context";
import DateRangePicker from "../../components/date-range-picker";
import StatusAnalyticsDateRangeFilter from "./components/status-analytics-date-range-filter";

export const StatusAnalytics = (props) => {
  // const [selectedDate, setSelectedDate] = useState(dayjs());



  const [selectedDataType, setSelectedDataType] = useState(DATA_TYPE_OPTIONS[0].label);
  const { fromDate: syncedFromDate, toDate: syncedToDate, enableDateSync } = useAnalyticsSyncDate();

  // These are local global states for dates because there are 3 to 4 charts
  // And we need the option to have this date range picker that will sync with all 
  // of them 
  const [fromDate, setFromDate] = useState(() => enableDateSync ? dayjs(syncedFromDate) : dayjs().startOf('month'));
  const [toDate, setToDate] = useState(() => enableDateSync ? dayjs(syncedToDate) : dayjs().endOf('month'));


  useEffect(() => {
    console.log('StatusAnalytics sync date context', {
      fromDate: syncedFromDate,
      toDate: syncedToDate,
      enableDateSync,
    });

    // If date sync is enabled, update local state to match synced dates
    if (enableDateSync) {
      if (syncedFromDate) {
        setFromDate(dayjs(syncedFromDate));
      }
      if (syncedToDate) {
        setToDate(dayjs(syncedToDate));
      }
    }

  }, [syncedFromDate, syncedToDate, enableDateSync]);

  // const handleDateChange = (newDate) => {
  //   setSelectedDate(newDate);
  // };

  // const handleDataTypeChange = (event) => {
  //   setSelectedDataType(event.target.value);
  // };

  const handleFromDateChange = (newDate) => {
    setFromDate(newDate ? dayjs(newDate) : null);
  };

  const handleToDateChange = (newDate) => {
    setToDate(newDate ? dayjs(newDate) : null);
  };


  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3, overflowX: "hidden" }}>
      <Typography variant="h5" component="h2" gutterBottom>
        Status Analytics
      </Typography>

      <StatusAnalyticsDateRangeFilter
        fromDate={fromDate}
        toDate={toDate}
        onFromChange={handleFromDateChange}
        onToChange={handleToDateChange}
      />

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <ConnectedCallsTable
          globalDataType={selectedDataType}
          fromDate={fromDate}
          toDate={toDate}
          onFromDateChange={handleFromDateChange}
          onToDateChange={handleToDateChange}
        />
        <UnreachedCallsTable
          globalDataType={selectedDataType}
          fromDate={fromDate}
          toDate={toDate}
          onFromDateChange={handleFromDateChange}
          onToDateChange={handleToDateChange}
        />
        <OtherStatusAnalyticsTable
          globalDataType={selectedDataType}
          fromDate={fromDate}
          toDate={toDate}
          onFromDateChange={handleFromDateChange}
          onToDateChange={handleToDateChange}
        />
        <SpecialStatusAnalyticsTable
          globalDataType={selectedDataType}
          fromDate={fromDate}
          toDate={toDate}
          onFromDateChange={handleFromDateChange}
          onToDateChange={handleToDateChange}
        />
      </Box>
    </Paper>
  );
};